import SwiperWithButtons from 'global/components/swipers/SwiperWithButtons';
import _ from 'lodash';
import { useMatchSchedule } from 'projectSpecific/sports/useHelpers/useMatchSchedule';
import { useMatchScheduleOptions } from 'projectSpecific/sports/useHelpers/useMatchScheduleOptions';
import React, { useContext, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import { formatItem, formatTypes, getFormattedDate } from '../../../../global/common/dateFormatting';
import { uniqueKey } from '../../../../global/common/keys';
import { gEnums } from '../../../../global/enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import SeasonMatchesProvider, { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext';
import SportsDataProvider from '../../cnr/contexts/SportsDataContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import ScheduleLegend from '../standings/ScheduleLegend';
import { LevelSchedule } from '../matches/LevelSchedule';
import { MatchCalendar } from '../matches/MatchCalendar';
import { _matchDisplayTypes } from '../matches/MatchContent';
import { MatchDataUpdateContext } from '../matches/MatchDataUpdate';
import MatchFilter from '../matches/MatchFilter';
import { getMatchesDivs } from '../matches/MatchLevelPlayoffDateSchedule';
import MatchScheduleHeader from '../matches/MatchScheduleHeader';
import MotionWrapper from 'global/motions/MotionWrapper';
import { _matchLsTypes } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer';
import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
import { Scoreboard } from '../matches/Scoreboard';

const sidebarType = 'matchList';

const _labelSize = 'tiny'

const _sidebarItemTypes = {
  matchDates: 'matchDates',
  districts: 'districts',
  levels: 'levels',
};

export const LevelSchedules = (props) => {

  const {
    _levelDateGroups,
    forBackup,
    forPlayoff,
    matchScheduleDisplayType,
    teamKey,
  } = props;

  let _matchScheduleDisplayType = matchScheduleDisplayType || gEnums.matchScheduleDisplayTypes.clickedDates
  let _useScrollRef = false

  switch (_matchScheduleDisplayType) {
    case gEnums.matchScheduleDisplayTypes.levelTabsFull:
      _useScrollRef = true;
    default:
    // nothing
  }

  // Contexts
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {};
  const { paps_state, appUser_state } = states ?? {};
  const { navigation_fns } = fns ?? {};

  const { appUser } = appUser_state ?? {};
  const appUserAccess = useAppUserAccess();
  const { accessLevel } = appUserAccess ?? {};

  const { profileData } = appUser ?? {};
  const { favs_info } = profileData ?? {};
  const { eventFavs } = favs_info ?? {};
  const { teams: team_favs } = eventFavs ?? {};
  const team_fav_keys = team_favs ? _.keys(team_favs) : null

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {};
  const { matches_info, seasonMatches_info } = sportsSeason_state ?? {};
  const _matches_info = forBackup && seasonMatches_info ? seasonMatches_info : matches_info;
  const { matches_groupInfo } = _matches_info ?? {};
  const { levelKeys, levelLatestStartDates } = matches_groupInfo ?? {};

  // matchDataUpdateContext
  const matchDataUpdateContext = useContext(MatchDataUpdateContext);
  const { sportsData_state } = matchDataUpdateContext ?? {};
  const { matchPlayoffPendings } = sportsData_state ?? {};

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchFilter, _shows_matches, commonMatches } = seasonMatches_state ?? {}

  const [showMatchHeader, setShowMatchHeader] = useState()
  const [showMissingOnly, setShowMissingOnly] = useState()
  const [selectedDate, setSelectedDate] = useState()
  const [selectedLevelKey, setSelectedLevelKey] = useState()
  const [showMissingMatches, setShowMissingMatches] = useState()
  const [activeTabIndex, setActiveTabIndex] = useState()
  const [selectedGotoLevel, setSelectedGotoLevel] = useState()

  const _dateCaption = formatItem(formatTypes.fullDate, selectedDate)

  const {
    teamCalendar: showTeamCalendar,
    calendar: showCalendar,
    // expand: showExpand,
    // newMatch: showNewMatch,
  } = _shows_matches ?? {}

  // Reducer for Sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(
    sidebarReducer,
    sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers })
  );

  const sidebar_handlers = sidebarHandlers(sidebar_dispatch);
  const { sidebar_items } = sidebar_state ?? {};
  const { setInit } = sidebar_handlers ?? {};
  const { ms_levels } = sidebar_items ?? {};
  const { selected } = ms_levels ?? {};
  const { itemKey: levelKeySelected } = selected ?? {};

  const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled };

  // const levelRefs = useRef({});
  // const scrolledLevels = useRef(new Set());
  // const currentLevelKeyRef = useRef(levelKeySelected);


  // useEffect(() => {
  //   currentLevelKeyRef.current = levelKeySelected;
  // }, [levelKeySelected]);

  const handleScroll_toToday = (xxx) => {
    setSelectedGotoLevel(activeTabIndex)
    // const selectedRef = levelRefs?.current[currentLevelKeyRef?.current];
    // console.log('selectedRef', selectedRef)
    // if (selectedRef) {
    //   selectedRef.current.scrollIntoView({ behavior: 'instant', block: 'start' }); // Scroll instantly to that ref
    // }
  }

  const handleTodayClick = () => setSelectedDate(getFormattedDate(new Date()))

  const handleDateClick = (forward) => {

    if (!selectedDate) return;

    const [month, day, year] = selectedDate.split('/').map(Number);
    const currentDate = new Date(year, month - 1, day);

    currentDate.setDate(currentDate.getDate() + (forward ? 1 : -1));

    const _selectedDate = currentDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });

    setShowMissingMatches(false)

    if (_selectedDate) {
      setSelectedDate(_selectedDate);
    }
  };

  const handleShowMissingMatches = () => setShowMissingMatches(!showMissingMatches)

  useEffect(() => {
    setSelectedDate(getFormattedDate(new Date()))
  }, []);

  useEffect(() => {
    setSelectedLevelKey(levelKeySelected)
  }, [levelKeySelected]);

  useEffect(() => {
    if (levelKeys) {
      const levelKeysFiltered = _.without(levelKeys, _matchLsTypes.Non);
      setInit({
        smt: sidebarMenuTypes.three,
        items: levelKeysFiltered,
        as: _sidebarItemTypes.levels,
        includeSearch: true,
        ..._initProps,
      });
    }
  }, [levelKeys]);

  // useEffect(() => {
  //   if (levelKeySelected && !scrolledLevels.current.has(levelKeySelected)) {
  //     const selectedRef = levelRefs?.current[levelKeySelected];
  //     if (selectedRef?.current) {
  //       console.log('selectedRef', selectedRef)
  //       selectedRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       scrolledLevels.current.add(levelKeySelected); // Mark this key as already scrolled
  //     }
  //   }
  // }, [levelKeySelected]);

  // Path views
  const { pathViews } = paps_state ?? {};

  const { _matchDisplayType, _matchDisplayOptions } = useMatchScheduleOptions(props)
  const { levelSectionDateMatches, scheduleLevelKeys, matchLevelGroups, matchLevelReversedGroups, matchesSummary } = useMatchSchedule(props, selectedDate)

  console.log('scheduleLevelKeys', scheduleLevelKeys)

  const handleActiveIndex = (index) => setActiveTabIndex(index)

  // levelMatches only
  const scheduleSwiper = (dls) => {

    const _caption = (key) => {
      switch (key) {
        case _matchLsTypes.Non:
          return 'NS'
        case 'nonDistrict':
          return 'ND'
        default:
          return key
      }
    }

    const _swiperItems = _.sortBy(
      _.toPairs(dls),
      ([key]) => key
    )
      .reverse()
      .map(([lgmeKey, lgme]) => ({
        key: lgmeKey,
        content: lgme,
        caption: _caption(lgmeKey),
      }));

    return {
      swipeItems: _swiperItems,
      sidebarItems: ms_levels,
      sidebar_handlers
    };
  };

  // const xxx = filterByMatchDate(levelSectionDateMatches, selectedDate)

  // MatchSchedules > LevelSchedule
  const ddd = useMemo(() => {
    switch (_matchDisplayType) {
      case _matchDisplayTypes.scoreboard:
      // return filterByMatchDate(levelSectionDateMatches, selectedDate)
      case _matchDisplayTypes.levelMatches:
        return levelSectionDateMatches
      case _matchDisplayTypes.levelOverviewMatches:
        return levelSectionDateMatches
      case _matchDisplayTypes.teamMatches:
        return levelSectionDateMatches
      default:
        return <div>{_matchDisplayType}</div>
    }

  })


  const content_levels = useMemo(() => {

    const divs_levels = [];
    const divs_levelDates = [];

    let _excludedKeys = ['tournament', 'playoff']

    switch (_matchScheduleDisplayType) {
      case gEnums.matchScheduleDisplayTypes.missing:
      case gEnums.matchScheduleDisplayTypes.matchDay:
      case gEnums.matchScheduleDisplayTypes.currentMatches:
        // add to the _excludedKeys
        break;
      default:
        _excludedKeys = _.union(_excludedKeys, [_matchLsTypes.nonLevel, _matchLsTypes.Non, _matchLsTypes.nonDistrict]);
      // nothing
    }

    const filteredMatchLevels = _.filter(matchLevelReversedGroups, ([levelKey]) => {
      return !_excludedKeys.includes(levelKey);
    });

    // console.log('ddd', _matchDisplayType, ddd)

    _.forEach(ddd, (lsdm, levelKey) => {
      const divs_matchxxxes = <LevelSchedule
        // levelGroup={levelGroup}
        scheduleLevelKeys={scheduleLevelKeys}
        lsdm={lsdm}
        levelKey={levelKey}
        showMissingMatches={showMissingMatches}
        teamKey={teamKey}
        matchDisplayType={_matchDisplayType}
        matchScheduleDisplayType={_matchScheduleDisplayType}
        team_fav_keys={team_fav_keys}
        matchesSummary={matchesSummary}
      // activeTabIndex={activeTabIndex}
      // activeTab={index === activeTabIndex}
      // gotoSelected={index === selectedGotoLevel}
      // lastLevelDate={lastLevelDate}
      />
      divs_levels.push(
        divs_matchxxxes
      )
      divs_levelDates[levelKey] = divs_matchxxxes
      // console.log('divs_matchxxxes', levelKey, divs_matchxxxes)
    })


    // loop the filteredMatchLevels
    // _.forEach(filteredMatchLevels, ([levelKey, levelGroup], index) => {

    //   const lastLevelDate = levelLatestStartDates?.[levelKey]

    //   const divs_matches = <LevelSchedule
    //     levelGroup={levelGroup}
    //     levelKey={levelKey}
    //     showMissingMatches={showMissingMatches}
    //     teamKey={teamKey}
    //     matchDisplayType={_matchDisplayType}
    //     matchScheduleDisplayType={_matchScheduleDisplayType}
    //     team_fav_keys={team_fav_keys}
    //     // activeTabIndex={activeTabIndex}
    //     // activeTab={index === activeTabIndex}
    //     gotoSelected={index === selectedGotoLevel}
    //     matchesSummary={matchesSummary}

    //   // lastLevelDate={lastLevelDate}
    //   />

    //   divs_levels.push(
    //     <div key={levelKey} className={_.kebabCase(_matchDisplayType)}>
    //       {_matchDisplayOptions.showLevelHeader && <div className="level-header">{levelKey}</div>}
    //       {!_.isEmpty(divs_matches) ? divs_matches : <div style={{ padding: '1em' }}>{'No Matches'}</div>}
    //     </div>
    //   );

    //   divs_levelDates[levelKey] = <div key={levelKey} className={_.kebabCase(_matchDisplayType)}>
    //     {!_.isEmpty(divs_matches) ? divs_matches : <div style={{ padding: '1em' }}>{'No Matches'}</div>}
    //   </div>
    //   // }

    // });

    return { divs_levels, divs_levelDates };

  }, [ddd, _matchDisplayType, matchLevelReversedGroups, _matchDisplayType, selectedDate, matchLevelGroups, _matchScheduleDisplayType])

  // scoreboard only
  const topDatesHeader = useMemo(() => {
    return <div className='date-header'>
      <div><Icon name='arrow left' onClick={() => { handleDateClick(false) }} /></div>
      <div>{_dateCaption}</div>
      <div>
        <Icon name='calendar check outline' onClick={() => { handleTodayClick(true) }} />
        <Icon name='arrow right' onClick={() => { handleDateClick(true) }} />
      </div>
    </div>
  }, [])

  const content_schedule_scoreboard = useMemo(() => {
    if (_matchDisplayType !== _matchDisplayTypes.scoreboard) { return {} }
    const { divs_levels } = content_levels
    return <Wrapper key={'asdfafafd'}
      header={_matchDisplayOptions?.showDataHeader && topDatesHeader}
      content={<MotionWrapper wrapperKey={`scoreboard-${selectedDate}`}>
        <Scoreboard
          scheduleLevelKeys={scheduleLevelKeys}
          lsdm={levelSectionDateMatches}
          selectedDate={selectedDate}
        />
        {/* <div>
          {divs_levels}
          <div>{<ScheduleLegend />}</div>
        </div> */}
      </MotionWrapper>}
      wrapperType={wrapperTypes.paddedHeader}
    ></Wrapper>
  }, [_matchDisplayType, content_levels]);

  const content_schedule_levelMatches = useMemo(() => {
    if (_matchDisplayType !== _matchDisplayTypes.levelMatches) { return {} }
    const { divs_levelDates } = content_levels
    const _scheduleSwiper = scheduleSwiper(divs_levelDates)
    return <MiniSwiper
      includeButtons={true}
      swipeItems={_scheduleSwiper?.swipeItems}
      showButtons={true}
    />
  }, [_matchDisplayType, content_levels]);

  const content_schedule_levelOverviewMatches = useMemo(() => {
    if (_matchDisplayType !== _matchDisplayTypes.levelOverviewMatches) { return {} }
    const sortedMatches = _.sortBy(matchLevelGroups, match => new Date(match.startDate));
    const divs_dates = getMatchesDivs(sortedMatches, _matchDisplayType, _matchScheduleDisplayType, pathViews.teams ? pathViews.teams : pathViews.matches)
    return <Wrapper
      header={_matchDisplayOptions?.showMatchFilter && <MatchFilter />}
      content={divs_dates}
      css={{ container: _.kebabCase(_matchDisplayType) }
      }
    />
  }, [_matchDisplayType, matchLevelGroups]);

  const content_schedule_teamMatches = () => useMemo(() => {
    if (_matchDisplayType !== _matchDisplayTypes.teamMatches) { return {} }
    const sortedTeamMatches = _.sortBy(matchLevelGroups, match => new Date(match.startDate));
    const divs_teamDates = getMatchesDivs(sortedTeamMatches, _matchDisplayType, _matchScheduleDisplayType, teamKey ? teamKey : pathViews.teams)
    return <Wrapper
      header={_matchDisplayOptions?.showMatchFilter && <MatchFilter />}
      content={divs_teamDates}
      css={{ container: _.kebabCase(_matchDisplayType) }}
      noMid={forPlayoff}
    />
  }, [_matchDisplayType]);

  switch (_matchDisplayType) {
    case _matchDisplayTypes.scoreboard:
      return content_schedule_scoreboard
    case _matchDisplayTypes.levelMatches:
      return content_schedule_levelMatches
    case _matchDisplayTypes.levelOverviewMatches:
      return content_schedule_levelOverviewMatches
    case _matchDisplayTypes.teamMatches:
      return content_schedule_teamMatches
    default:
      return <div>{_matchDisplayType}</div>
  }

  // return content_schedule

};

/**
 * 
 * @param {object} props 
 * @returns the MatchSchedule componnent wrapped with SeasonMatchesProvider
 */
const LevelSchedulesWithProvider = React.memo((props) => {
  return <SportsDataProvider>
    <SeasonMatchesProvider  {...props}>
      <LevelSchedules {...props} />
    </SeasonMatchesProvider>
  </SportsDataProvider>
});

export default LevelSchedulesWithProvider